import { render } from "./DialogMassiveInviteResidents.vue?vue&type=template&id=4e395258&ts=true"
import script from "./DialogMassiveInviteResidents.ts?vue&type=script&lang=ts"
export * from "./DialogMassiveInviteResidents.ts?vue&type=script&lang=ts"

import "./DialogMassiveInviteResidents.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/vsts/work/1/s/Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__